export const PAGES = {
  UPCOMING: "UPCOMING",
  DRAFT: "DRAFT",
  ARCHIVE: "ARCHIVE",
  PLANNER: "PLANNER",
  CALENDAR: "CALENDAR",
} as const;

export type PageName = (typeof PAGES)[keyof typeof PAGES];
